/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Schema_Desc6Inputs */

const en_svc_programmatic_seo_schema_desc6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valid structured data per page type, tested before deploy.`)
};

const ar_svc_programmatic_seo_schema_desc6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بيانات منظمة صالحة لكل نوع صفحة، تختبر قبل النشر.`)
};

const bn_svc_programmatic_seo_schema_desc6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতি পৃষ্ঠা ধরনে বৈধ কাঠামোগত ডেটা, ডিপ্লয়ের আগে পরীক্ষিত।`)
};

const de_svc_programmatic_seo_schema_desc6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gültige strukturierte Daten pro Seitentyp, getestet vor dem Deploy.`)
};

const es_svc_programmatic_seo_schema_desc6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos estructurados válidos por tipo de página, probados antes de desplegar.`)
};

const fr_svc_programmatic_seo_schema_desc6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données structurées valides par type de page, testées avant déploiement.`)
};

const pt_svc_programmatic_seo_schema_desc6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados estruturados válidos por tipo de página, testados antes de publicar.`)
};

const zh_svc_programmatic_seo_schema_desc6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按页面类型配有效的结构化数据，上线前测过。`)
};

const tr_svc_programmatic_seo_schema_desc6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sayfa tipine göre geçerli yapısal veri, yayın öncesi testli.`)
};

const ru_svc_programmatic_seo_schema_desc6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Валидные структурированные данные под тип страницы, проверенные до деплоя.`)
};

const pl_svc_programmatic_seo_schema_desc6 = /** @type {(inputs: Svc_Programmatic_Seo_Schema_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poprawne dane strukturalne pod typ strony, przetestowane przed wdrożeniem.`)
};

/**
* | output |
* | --- |
* | "Valid structured data per page type, tested before deploy." |
*
* @param {Svc_Programmatic_Seo_Schema_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_schema_desc6 = /** @type {((inputs?: Svc_Programmatic_Seo_Schema_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Schema_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_schema_desc6(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_schema_desc6(inputs)
	if (locale === "de") return de_svc_programmatic_seo_schema_desc6(inputs)
	if (locale === "es") return es_svc_programmatic_seo_schema_desc6(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_schema_desc6(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_schema_desc6(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_schema_desc6(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_schema_desc6(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_schema_desc6(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_schema_desc6(inputs)
	return en_svc_programmatic_seo_schema_desc6(inputs)
});
export { svc_programmatic_seo_schema_desc6 as "svc_programmatic-seo_SCHEMA_desc" }